import React from 'react';
import { useTranslation } from 'react-i18next';

import downloadIconCPAY from '../../img/cpay-svg/download.svg';
import downloadIconNFG from '../../img/nfgpay-svg/download.svg';
import downloadIconFinvaro from '../../img/finvaro/download.svg';
import downloadIconClarnium from '../../img/clarnium/download.svg';
import downloadIconInex from '../../img/inex/download.svg';
import downloadIconInsta from '../../img/instaXchange/download.svg';

import { identity } from '../../utils/getIdentity';
import Button from '../Button';

import './MerchantSecurity.scss';

const downloadIcon = {
  cpay: downloadIconCPAY,
  nfg: downloadIconNFG,
  finvaro: downloadIconFinvaro,
  clarnium: downloadIconClarnium,
  inex: downloadIconInex,
  insta: downloadIconInsta
};

const MerchantSecurity = () => {
  const { t } = useTranslation();

  return (
    <div className={`component component-${identity} merchant-security`}>
      <div className={`merchant-security__title merchant-security__title-${identity}`}>
        <h2>{t('merchants.security.security')}</h2>
        <div>
          <img src={downloadIcon[identity]} alt="Download" />
          <p>{t('merchants.security.download')}</p>
        </div>
      </div>

      <div className={`merchant-security__info merchant-security__info-${identity}`}>
        <p>
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's
          standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to
          make a type specimen book. It has survived not only five centuries, but also the leap into electronic
          typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset
          sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus
          PageMaker including versions of Lorem Ipsum.{' '}
          <a href="https://docs.gemewallet.com/" rel="noopener noreferrer" target="_blank">
            {t('footer.documentation')}
          </a>
        </p>
      </div>

      <div className={`merchant-security__actions merchant-security__actions-${identity}`}>
        <Button type="primary">{t('merchants.security.setAutosign')}</Button>
        <Button type="secondary">{t('merchants.security.changeAutosign')}</Button>
      </div>
    </div>
  );
};

export default MerchantSecurity;
